import React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import ButtonBase from "@material-ui/core/ButtonBase";
import { useRptCa, useRptMain } from "../../../../St/Reviews/UseStyle";

function HeaderCashiar({info}) {
  const clasm = useRptMain();
  const clas = useRptCa();

  return (
    <Grid item container className={clas.Hedroot}>
      <Grid item xs={12} className={clasm.mincntr}>
        <Typography>
          <ButtonBase>
            {" "}
            <img
              src={`data:image/jpeg;base64,${info.Logo}`}
              className={clas.Hedlogo}
              alt={info.nameA}
            />{" "}
          </ButtonBase>
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Typography className={clasm.mincntr}><div style={{fontWeight:"bold",fontSize:"1rem"}}>{info.nameA}</div></Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography className={clasm.mincntr} style={{fontWeight:"bold",fontSize:"1rem"}} >{info.nameE}</Typography>
      </Grid>
    </Grid>
  );
}
export default HeaderCashiar;
